module.exports = __webpack_public_path__ + "static/media/ajb-two-small-min.302bc7a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/ajb/ajb-two-small-min.png
// module id = 807
// module chunks = 0